@if(isBack) {
  <button
    mat-button
    [class]="[extraClass, extraColorClass, 'backButtonButton', 'button']"
    (click)="onClick($event)"
  >
    <mat-icon>arrow_back_ios</mat-icon> <span>Back</span>
  </button>
}
@else if (icon) {
  @switch (format) {
    @case ('icon'){
      <button
        mat-icon-button
        [attr.aria-label]="label"
        [class]="[extraClass, extraColorClass, 'button']"
        [disabled]="disabled"
        (click)="onClick($event)"
        >
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    }

    @case ('fab'){
      <button
        mat-fab
        [attr.aria-label]="label"
        [class]="[extraClass, extraColorClass, 'button']"
        [disabled]="disabled"
        (click)="onClick($event)"
        >
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    }

    @case ('basic'){
      <button mat-button
              [class]="[extraClass, extraColorClass, 'button']"
              [color]="color"
              [disabled]="disabled"
              [type]="type"
              (click)="onClick($event)"
      >
        <mat-icon>{{ icon }}</mat-icon> {{ label }}
      </button>
    }

    @case ('flat'){
      <button
        mat-flat-button
        [attr.aria-label]="label"
        [class]="[extraClass, extraColorClass, 'button']"
        [disabled]="disabled"
        (click)="onClick($event)"
        >
        <mat-icon>{{ icon }}</mat-icon> {{ label }}
      </button>
    }

    @default{
      <button
        mat-mini-fab
        [attr.aria-label]="label"
        [class]="[extraClass, extraColorClass, 'button']"
        [disabled]="disabled"
        (click)="onClick($event)"
      >
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    }
  }
} @else {
  @switch (format) {
    @case ('basic'){
      <button mat-flat-button
              [class]="[extraClass, extraColorClass, 'button']"
              [color]="color"
              [disabled]="disabled"
              [type]="type"
              (click)="onClick($event)"
      > {{ label }} </button>
    }
    @default { <!-- flat -->
      <button mat-flat-button
              [class]="[extraClass, extraColorClass, 'button']"
              [color]="color"
              [disabled]="disabled"
              [type]="type"
              (click)="onClick($event)"
      > {{ label }} </button>
    }
  }
}
